import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNewbuildingListingUrl } from './useNewbuildingListingUrl';
import { BannerPopup } from '../../components/BannerPopup';
import { selectBannerPopup } from '../../selectors/promosPage';

interface IBannerPopupContainerProps {
  open: boolean;
  onClose(): void;
}

export const BannerPopupContainer: React.FC<IBannerPopupContainerProps> = props => {
  const popup = useSelector(selectBannerPopup);
  const newbuildingListingUrl = useNewbuildingListingUrl();

  if (!popup) {
    return null;
  }

  return (
    <BannerPopup
      {...props}
      description={popup.description}
      props={popup.props}
      title={popup.name}
      newbuildingListingUrl={newbuildingListingUrl}
      internalBannerUrl={popup.internalBannerUrl}
    />
  );
};
